<template>
  <div class="page">
    <div class="page-container">
      <div class="page-col">
        <h2>Seller Info</h2>
        <div class="page-data-grid has-nested">
          <div class="page-data-item">
            <img src="../buyer-listing-details/full-details-content/assets/badge.svg" />
            <span>{{ listing.owners }}</span>
            <label>{{ ownerLabel }}</label>
          </div>

          <div class="page-data-item nested">
            <div class="page-svg-wrapper">
              <div>
                <InfoGridDecorativeLines />
              </div>
            </div>
            <img src="../buyer-listing-details/full-details-content/assets/laurel.svg" />
            <div>
              <label>Owner Licenses:</label>
              <span>{{ listing.owner_licenses }}</span>
            </div>
          </div>

          <div class="page-data-item nested">
            <div></div>
            <img src="../buyer-listing-details/full-details-content/assets/ribbon.svg" />
            <div>
              <label>Owner Designations:</label>
              <span>{{ listing.owner_designations }}</span>
            </div>
          </div>

          <div class="page-data-item">
            <img src="../buyer-listing-details/full-details-content/assets/compass.svg" />
            <span>{{ listing.years_in_business }}</span>
            <label>{{ yearLabel }}</label>
          </div>
        </div>
      </div>

      <div class="page-col page-col-team">
        <h2>Team Info</h2>

        <div class="page-data-grid has-nested">
          <div class="page-data-item">
            <img src="../buyer-listing-details/full-details-content/assets/employees-laurel.svg" />
            <span>{{ listing.team_licensed_employees }}</span>
            <label>Licensed Employees</label>
          </div>

          <div class="page-data-item nested">
            <div class="page-svg-wrapper">
              <div>
                <InfoGridDecorativeLines />
              </div>
            </div>
            <img src="../buyer-listing-details/full-details-content/assets/laurel.svg" />
            <div>
              <label>Employee Licenses:</label>
              <span>{{ listing.team_employee_licenses }}</span>
            </div>
          </div>

          <div class="page-data-item nested">
            <div></div>
            <img src="../buyer-listing-details/full-details-content/assets/ribbon.svg" />
            <div>
              <label>Employee Designations:</label>
              <span>{{ listing.team_employee_designations }}</span>
            </div>
          </div>

          <div class="page-data-item">
            <img src="../buyer-listing-details/full-details-content/assets/employees.svg" />
            <span>{{ listing.team_unlicensed_employees }}</span>
            <label>Unlicensed Employees</label>
          </div>
        </div>
      </div>
    </div>

    <h2 style="margin-top: 10px;">Company Info</h2>
    <div class="d-flex pa-5 mt-3 mb-9 justify-center association_box">
      <div class="d-inline text-center align-start" style="width: 33%">
        <img src="../buyer-listing-details/full-details-content/assets/broker-dealer.svg" class="d-block" style="margin:0 auto" />
        <span class="d-block sansation font-weight-black grow--text association_title">Broker-Dealer</span>
        <label class="d-block">{{ listing.brokerDealer }}</label>
      </div>

      <div class="d-inline text-center align-start" style="width: 34%">
        <img src="../buyer-listing-details/full-details-content/assets/custodians.svg" class="d-block" style="margin:0 auto" />
        <span class="d-block sansation font-weight-black grow--text association_title">Custodians</span>
        <label class="d-block">{{ listing.custodians }}</label>
      </div>

      <div class="d-inline text-center align-start" style="width: 33%">
        <img src="../buyer-listing-details/full-details-content/assets/tamps.svg" class="d-block" style="margin:0 auto" />
        <span class="d-block sansation font-weight-black grow--text association_title">TAMPS</span>
        <label class="d-block">{{ listing.tamps }}</label>
      </div>
    </div>

    <div class="page-data-grid data-grid-table">
      <div class="page-data-item py-2">
        <img src="../buyer-listing-details/full-details-content/assets/house.svg" />
        <span>{{ listing.company_households }}</span>
        <label>{{ householdLabel }}</label>
      </div>

      <div class="page-data-item py-2">
        <img src="../buyer-listing-details/full-details-content/assets/plant.svg" />
        <span>{{ listing.company_average_client_age }}</span>
        <label>Average Client Age</label>
      </div>

      <div class="page-data-item py-2">
        <img src="../buyer-listing-details/full-details-content/assets/map.svg" />
        <span>{{ listing.company_local_clients }}%</span>
        <label>Local Clients</label>
      </div>

      <div class="page-data-item py-2">
        <img src="../buyer-listing-details/full-details-content/assets/coins.svg" />
        <span>{{ listing.company_households_1m_aum }}</span>
        <label>{{ houseHoldHighAumLabel }}</label>
      </div>

      <div class="page-data-item py-2">
        <img src="../buyer-listing-details/full-details-content/assets/clock.svg" />
        <span>{{ listing.company_average_client_tenture }}</span>
        <label>Years Ave Client Tenure</label>
      </div>

      <div class="page-data-item py-2 nested">
        <img src="../buyer-listing-details/full-details-content/assets/multi-gen.svg" />
        <div class="pt-1">
          <label>Multi-Generational Planning:</label>
          <span>{{ listing.company_multi_gen_plan ? 'Yes' : 'No' }}</span>
        </div>
      </div>
    
      <div class="page-data-item py-2 nested">
        <img src="../buyer-listing-details/full-details-content/assets/network.svg" />
        <div class="pt-3">
          <label>Key Methods for Client Acquisition:</label>
          <span>{{ listing.company_key_method_acquisition }}</span>
        </div>
      </div>

    </div>

    <BottomColorBar />
  </div>
</template>

<script>
import dateformat from 'dateformat'

import BottomColorBar from './partials/BottomColorBar'
import InfoGridDecorativeLines from './partials/InfoGridDecorativeLines'

export default {
  name: 'PdfPage2',
  components: {
    BottomColorBar,
    InfoGridDecorativeLines,
  },
  props: {
    listing: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    ownerLabel () {
      const num = Number(this.listing.owners)
      return `Owner${num === 1 ? '' : 's'}`
    },

    yearLabel () {
      const num = Number(this.listing.years_in_business)
      return `Year${num === 1 ? '' : 's'} in Business`
    },

    householdLabel () {
      const num = Number(this.listing.company_households)
      return `Household${num === 1 ? '' : 's'}`
    },

    houseHoldHighAumLabel () {
      const num = Number(this.listing.company_households_1m_aum)
      return `Household${num === 1 ? '' : 's'} with 1M+ in AUM`
    },
  },
}
</script>

<style scoped>
.pdf-content .page {
  padding-top: 40pt;
  padding-left: 30pt;
  padding-right: 30pt;
}

.page-container {
  display: flex;
  height: 350px;
}

.page-col {
  flex: 1 0 50%;
  padding: 25px;
}

.page-col.page-col-team {
  background-color: #99CC3311;
}

.page-col h2 {
  margin-bottom: 20px;
}

.page-data-grid.has-nested .page-data-item > span:nth-child(2) {
  text-align: center;
}

.page-data-item {
  display: grid;
  grid-template-columns: 35px 35px auto;
  grid-column-gap: 10px;
  align-items: center;
  justify-content: left;
}

.page-svg-wrapper {
  position: relative;
  height: 100%;
  width: 100%;
}

.page-svg-wrapper div {
  position: absolute;
  top: -20px;
  left: 0;
  right: 0;
  height: calc(200% + 60px);
}

.page-data-card .page-data-item {
  grid-template-columns: auto;
  grid-template-rows: auto auto auto;

  text-align: center;
}

.page-data-card img {
  width: 60px;
  margin: 0 auto 10px;
}

.page-data-card label {
  /* max-width: 150px; */
    width: 100%;
}

.association_title {
  font-size: 1.1rem !important
}
.association_box {
  width: 100%; 
  border:3px dashed #97C131;
}

</style>



// WEBPACK FOOTER //
// src/components/buyer-listing-details-as-pdf/PdfPage2.vue